export default {
  home: {
    hero: {
      title: '化学品取引の「見えないリスク」を引き受ける。',
    },
    news: {
      eyebrow: ' ',
      title: 'ニュース',
      readMore: '続きを読む',
    },
    chemicals: {
      eyebrow: ' ',
      title: '化学品リスト',
      description:
        '化学品の輸出入および販売に必要な許認可を有し、世界中のお客様に高品質な化学品やレアメタルを安定的に供給しています。代表的な取扱製品の詳細は、以下よりご確認ください。',
      cta: 'リストを見る',
    },
    importExport: {
      eyebrow: ' ',
      title: '貿易用語集',
      description:
        '国際貿易や物流でよく使われる用語を、素早く理解できるように分かりやすく解説した、輸出入の基本用語集です。',
      cta: '用語集を見る',
    },
    purchaseProcess: {
      eyebrow: ' ',
      title: '輸出手続きの流れ',
      description:
        '初回のお問い合わせから製品のお届けまで、一連の流れをわかりやすくご案内いたします。',
      cta: '全ての流れを見る',
    },
    newsItems: [
      { id: 'scholarship-repayment-2024', title: '奨学金返還支援制度を導入いたしました', date: '2024年8月15日' },
      { id: 'relocation-chuo-2023', title: '大阪市中央区に移転いたしました', date: '2023年6月5日' },
      { id: 'trade-terminology-2015', title: '貿易用語集ページを公開しました', date: '2023年4月1日' },
    ],
  },
};
